import { EventInformationFragment } from '../Drawer.generated'
import { DetailsList, DetailItem } from './DetailsList'
import { MultiValueItem, MultiValueList } from './DetailsList/Multi'
import FacilitiesDetailItem from './FacilitiesDetail'
import {
  formatAttendees,
  formatBudget,
  formatContactDetails,
  formatFlexibility,
  formatLocation,
  formatQuote,
  formatStyles,
  formatSubmissionDate,
  formatTimings,
} from './Formatting'

interface EventDetailsProps extends EventInformationFragment {
  isDirectEnquiry: boolean
}

const EventDetails = ({
  currency,
  location,
  radius,
  budget,
  layout,
  guest,
  guestsCount,
  eventDateFrom,
  eventDateTo,
  flexibleDates: legacyFlexibleDates,
  flexibility,
  isDirectEnquiry,
  optionalSpaceFacilities,
  requiredSpaceFacilities,
  spaceStyles,
  cateringNeeds,
  notes,
  createDate,
}: EventDetailsProps): JSX.Element | null => {
  const formattedStyles = formatStyles(spaceStyles).map(({ id, label }) => (
    <MultiValueItem key={id}>{label}</MultiValueItem>
  ))
  return (
    <DetailsList>
      <DetailItem heading='Preferred location'>
        {formatLocation({ radius, isDirectEnquiry, location })}
      </DetailItem>
      <DetailItem heading='Attendees' small>
        {formatAttendees({ guestsCount, layout })}
      </DetailItem>
      <DetailItem heading='Budget' small>
        {formatBudget({ currency, budget })}
      </DetailItem>
      <DetailItem heading='Timings'>
        {formatTimings({ eventDateFrom, eventDateTo })}
      </DetailItem>
      <DetailItem heading='Flexibility'>
        {formatFlexibility({ legacyFlexibleDates, ...flexibility })}
      </DetailItem>
      <FacilitiesDetailItem
        heading='Essential facilities'
        facilities={requiredSpaceFacilities}
      />
      <FacilitiesDetailItem
        heading='Desirable facilities'
        facilities={optionalSpaceFacilities}
      />
      <DetailItem heading='Venue style'>
        {formattedStyles.length > 0 && (
          <MultiValueList>{formattedStyles}</MultiValueList>
        )}
      </DetailItem>
      <DetailItem heading='Catering requests'>
        {formatQuote(cateringNeeds)}
      </DetailItem>
      <DetailItem heading='Additional notes'>{formatQuote(notes)}</DetailItem>
      <DetailItem heading='Your contact details'>
        {formatContactDetails(guest)}
      </DetailItem>
      <DetailItem heading='Enquiry submitted'>
        {formatSubmissionDate(createDate)}
      </DetailItem>
    </DetailsList>
  )
}

export default EventDetails
